const hideDialog = require("../dom/hideDialog");
const removeElement = require("../dom/removeElement");

/**
 * @param loadingDialog$ {HTMLDialogElement}
 */
module.exports = function hideLoadingDialog(loadingDialog$) {
    hideDialog(loadingDialog$);
    removeElement(loadingDialog$);
}
